// extracted by css-extract-rspack-plugin
export default {"upgradeBadge":"PD5ga73ugCA7Oc38"};